import { FeatureFlags } from '@/modules/featureFlags';
import { useFeatureFlag } from '@/modules/featureFlags/hooks';

export const useMyMoneyReimbursementFeatureFlag = () => {
  const isUseMyMoneyReimbursementEnabled = useFeatureFlag(FeatureFlags.USE_MY_MONEY_REIMBURSEMENT);
  return { isUseMyMoneyReimbursementEnabled };
};
